import { render, staticRenderFns } from "./ListCourses.vue?vue&type=template&id=2b6b0554&scoped=true&"
import script from "./ListCourses.vue?vue&type=script&lang=js&"
export * from "./ListCourses.vue?vue&type=script&lang=js&"
import style0 from "./ListCourses.vue?vue&type=style&index=0&id=2b6b0554&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b0554",
  null
  
)

export default component.exports